import { CheckCircleFilled } from "@ant-design/icons";
import { Badge, Flex, Space, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

export const StepHeader = ({
  title,
  description,
  showCheckIcon = false,
}: {
  title: string;
  description: React.ReactNode | string;
  showCheckIcon?: boolean;
}) => {
  const { theme } = useAntTheme();
  return (
    <Flex vertical component="header" align="center" justify="center" gap={20}>
      <Space size="small">
        {showCheckIcon && (
          <Badge
            count={
              <CheckCircleFilled
                style={{ color: theme.colorSuccess, fontSize: 32 }}
              />
            }
          />
        )}
        <Typography.Title
          level={2}
          style={{
            textAlign: "center",
            fontWeight: 500,
            margin: 0,
            padding: 0,
          }}
        >
          {title}
        </Typography.Title>
      </Space>

      {typeof description === "string" ? (
        <Typography.Text
          type="secondary"
          style={{ fontSize: 16, textAlign: "center" }}
        >
          {description}
        </Typography.Text>
      ) : (
        description
      )}
    </Flex>
  );
};
